import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { Loader2 } from 'lucide-react';

export default function ShortCodeRedirect() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) {
      setError('No code provided');
      return;
    }

    (async () => {
      const { data, error: rpcError } = await supabase.rpc(
        'resolve_cashier_count_short_code',
        { p_code: code }
      );

      if (rpcError || !data?.share_token) {
        setError('This link is invalid or has expired.');
        return;
      }

      navigate(`/cashier-count/${data.share_token}`, { replace: true });
    })();
  }, [code, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-2">
          <h1 className="text-lg font-semibold">Link Not Found</h1>
          <p className="text-sm text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}
